import React from "react";
import {connect} from 'react-redux';
import { Paper } from "@mui/material";
import ColorSelector from "./ColorSelector";
import Typography from "@mui/material/Typography";

const mapStateToProps = (state) => {
    return {
        map: state.MapReducer
    }
}

const StyleEditor = (props) => {

    let [_styleData, setSD] = React.useState(props.styleData);

    React.useEffect(()=>{
        setSD(props.styleData);
    }, [props.styleData]);
    // console.log(props.styleData)

    const updateColor = (color, idx) => {
        let _ls = {...props.styleData};
        _ls.breaks[idx] = {
            ..._ls.breaks[idx],
            color: color
        }
        props.onChange(_ls);
    }

    const updateValue = (value, vIdx, idx) => {
        let _ls = {..._styleData};
        let _vls = _ls.breaks[idx].values;
        if(value==='')
            value = '0'
        value = parseFloat(value);
        _vls[vIdx] = value;
        _ls.breaks[idx].name = `${_vls[0].toFixed(3)}-${_vls[1].toFixed(3)}`;
        _ls.breaks[idx] = {
            ..._ls.breaks[idx],
            values: _vls
        }
        setSD(_ls);
        // props.onChange(_ls);
    }

    return <Paper elevation={10} style={{minWidth: 150, paddingLeft: 16, maxHeight: 'calc(100vh - 90px)', overflowY: 'auto', border:1, borderStyle:'solid', padding:15, borderColor: '#e0e0e0', marginTop:10, borderRadius:15, backgroundColor: '#ffffff'}}>
        <Typography variant="caption" gutterBottom component="div">
        Style Editor
        </Typography>
        {
            props.styleData.breaks.map((style, idx)=>{
                return <div key={idx} style={{padding:3}}>
                    {/* <span style={{background: style.color}}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp; */}
                    <ColorSelector initColor={style.color} onColorChange={c=>{
                        updateColor(c, idx)
                    }} />&nbsp;&nbsp;


                    {
                        props.styleType==='range'?(
                            <>
                                <input style={{
                                        padding: 4,
                                        width: 100,
                                    }} 
                                    value={style.values[0]}
                                    type="number"
                                    onChange={(e)=>{
                                        updateValue(e.target.value, 0, idx)
                                    }}
                                    onBlur={()=>{
                                        props.onChange(_styleData);
                                    }}
                                    />
                                &nbsp;&nbsp;-&nbsp;&nbsp;
                                <input style={{
                                        padding: 4,
                                        width: 100,
                                    }}
                                    value={style.values[1]}
                                    // value={style.values[1].constructor.name==='String'?parseFloat(style.values[1]).toFixed(3):style.values[1].toFixed(3)}
                                    type="number"
                                    onChange={(e)=>{
                                        updateValue(e.target.value, 1, idx)
                                    }}
                                    onBlur={()=>{
                                        props.onChange(_styleData);
                                    }}
                                />
                            </>
                        ):(
                            <input style={{
                                padding: 4,
                                width: 100,
                            }}
                            value={style.values[0]}
                            type="text"
                            disabled
                            onChange={(e)=>{
                                updateValue(e.target.value, 0, idx)
                            }}
                            onBlur={()=>{
                                props.onChange(_styleData);
                            }}
                            />
                        )
                    }
                </div>
            })
        }
    </Paper>
}

export default connect(mapStateToProps)(StyleEditor);